import config from '../config';
import { auth } from '../firebase/firebase';

async function fetchWithRetry(url: string, options: RequestInit, retries = 1): Promise<Response> {
    for (let i = 0; i <= retries; i++) {
        const response = await fetch(url, options);
        if (response.status >= 500 && response.status < 600) {
            if (i === retries) {
                throw new Error(`HTTP error after ${retries + 1} tries! status: ${response.status}`);
            }
        } else {
            return response;
        }
    }
    throw new Error('fetchWithRetry failed without providing a response.');
}

const apiClient = {
  async request(method: string, endpoint: string, body: any = null, isPublic = false) {
    const url = `${config.coreApi.protocol}://${config.coreApi.host}/${endpoint}`;
    const headers: HeadersInit = { 'Content-Type': 'application/json' };

    if (!isPublic) {
      const token = await auth.currentUser?.getIdToken();
      if (!token) {
        throw new Error('User not authenticated.');
      }
      headers['Authorization'] = `Bearer ${token}`;
    }

    const options: RequestInit = { method, headers };
    if (body) {
      options.body = JSON.stringify(body);
    }

    const response = await fetchWithRetry(url, options);

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch (e) {
        errorData = { message: `HTTP error! status: ${response.status}` };
      }
      throw new Error(errorData.message || 'An unknown error occurred.');
    }

    if (response.status === 204) {
      return null;
    }

    return response.json();
  },
  get(endpoint: string, isPublic = false) {
    return this.request('GET', endpoint, null, isPublic);
  },
  post(endpoint: string, body: any, isPublic = false) {
    return this.request('POST', endpoint, body, isPublic);
  },
  patch(endpoint: string, body: any) {
    return this.request('PATCH', endpoint, body);
  },
  delete(endpoint: string) {
    return this.request('DELETE', endpoint);
  },
};

export default apiClient;